// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kx-1";
export var messageSideRight = "_kx-2";
export var subscribeToBackInStockBubbleContainer = "_kx-0";